var React = require('react');
var moment = require('moment');
var labels = require('MemberJoinLabels');
var { $datePicker, $simpleSelect, $radioButtons } = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationComponents.jsx');
var selectableDataFunctions = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/selectableDataFunctions.jsx');
var validationFunctions = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationFunctions.jsx');

class CompleteYourProfile extends React.Component {
    constructor(props) {
        super(props);

        this.bindFunctions();
    }

    bindFunctions() {
        this.handleGovernmentSectorChange = this.handleGovernmentSectorChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleMilitaryBranchChange = this.handleMilitaryBranchChange.bind(this);
        this.handleRaceInputChange = this.handleRaceInputChange.bind(this);
        this.getExtraMilitaryFieldsMarkup = this.getExtraMilitaryFieldsMarkup.bind(this);
        this.getExtraGovernmentEmployeeFieldsMarkup = this.getExtraGovernmentEmployeeFieldsMarkup.bind(this);
    }

    getExtraMilitaryFieldsMarkup() {
        if (this.props.appState.isMilitary) {
            return <div>
                <div className={"field-wrap"}>
                    <label>{labels.step3.branch}</label>
                    <$simpleSelect
                        value={this.props.stepState.branch}
                        selectoptions="militaryBranch"
                        name="branch"
                        selectdatafunction={selectableDataFunctions.getMilitaryBranchSelectableOptions}
                        onChange={this.handleMilitaryBranchChange}
                        validations={[validationFunctions.required]} />
                </div>
            </div>;
        }
    }

    getExtraGovernmentEmployeeFieldsMarkup() {
        if (this.props.appState.isGovernmentEmployee) {
            return <div className={"field-group-wrap"}>
                <label>{labels.step3.governmentSector}</label>
                       <$radioButtons
                       name="governmentSector"
                       value={this.props.stepState.governmentSector}
                       onChange={this.handleGovernmentSectorChange}
                       selectdatafunction={selectableDataFunctions.governmentSectorRadioButtons}
                       validations={[validationFunctions.required]} />
                   </div>;
        }
    }

    handleMilitaryBranchChange(event) {
        if (this.props.stepState.branchId) {
            this.props.updateStepState('branchIdToDelete', this.props.stepState.branchId);
            this.props.updateStepState('branchId', '');
        }
        
        this.handleInputChange(event);
    }

    handleGovernmentSectorChange(event) {
        if (this.props.stepState.governmentSectorId) {
            this.props.updateStepState('governmentSectorIdToDelete', this.props.stepState.governmentSectorId);
            this.props.updateStepState('governmentSectorId', '');
        }

        this.handleInputChange(event);
    }

    handleRaceInputChange(event) {
        this.props.updateStepStateMultiSelect(event.target.name, event.target.value, event.target.checked);
    }

    handleInputChange(event) {
        this.props.updateStepState(event.target.name, event.target.value);
    }

    render() {
        return <div className={"complete-profile-container"}>
            <div className={"row"}>
                <div className={"panel"}>
                    <div className={"col-md-12"}>
                        <h3>{labels.step3.completeYourProfile}</h3>
                    </div>
                    <div className={"edit"}>
                        <div className={"col-md-6"}>
                            <div className={"field-group-wrap"}>
                                {this.getExtraMilitaryFieldsMarkup()}
                                </div>

                            <div className={"field-group-wrap"}>
                                <label>{labels.step3.gender}</label>
                                <$radioButtons name="gender" value={this.props.stepState.gender} selectoptions="gender" onChange={this.handleInputChange} validations={[validationFunctions.required]} />
                            </div>

                            <div className={"field-group-wrap"}>
                                <label>{labels.step3.ethnicity}</label>
                                <$radioButtons name="ethnicity" value={this.props.stepState.ethnicity} onChange={this.handleInputChange} validations={[validationFunctions.required]} />
                            </div>

                            <div className={"field-group-wrap"}>
                                <label>{labels.step3.race}</label>

                                <$radioButtons name="race"
                                    value={this.props.stepState.race}
                                    onChange={this.handleInputChange}
                                    validations={[validationFunctions.required]} />

                                {this.getExtraGovernmentEmployeeFieldsMarkup()}
                            </div>

                            <div className={"field-group-wrap"}>
                                <label>{labels.step3.dob}</label>
                                <$datePicker
                                    value={this.props.stepState.birthdate && moment.utc(this.props.stepState.birthdate).isValid() ? moment.utc(this.props.stepState.birthdate).format('YYYY-MM-DD') : ""}
                                    onInput={this.handleInputChange}
                                    name="birthdate"
                                    type="date"
                                    date-format="yyyy-mm-dd"
                                    min={validationFunctions.getDobMinDate()}
                                    max={validationFunctions.getDobMaxDate()}
                                    validations={[validationFunctions.required, validationFunctions.date, validationFunctions.dateOfBirthAgeRange]} />
                            </div>
            
                        </div>
                    </div>
                </div>

            </div>
        </div>;
    }
}

module.exports = CompleteYourProfile;